export default "__VITE_ASSET__d15ff5e8__"